import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from 'src/lib';
import {
  cancelGetStandbyTravelersResultRequest,
  failGetStandbyTravelersResult,
  setGetStandbyTravelersResult,
  setGetStandbyTravelersResultFromApi,
  updateGetStandbyTravelersResult,
  updateGetStandbyTravelersResultFromApi,
} from './get-standby-travelers-result.actions';

/**
 * Service to handle async GetStandbyTravelersResult actions
 */
@Injectable()
export class GetStandbyTravelersResultEffect {
  /**
   * Set the state with the reply content, dispatch failGetStandbyTravelersResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetStandbyTravelersResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetStandbyTravelersResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetStandbyTravelersResult({ error, requestId: action.requestId })),
        cancelGetStandbyTravelersResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetStandbyTravelersResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetStandbyTravelersResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetStandbyTravelersResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetStandbyTravelersResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
